import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useContext, createContext } from 'react';
const ModalContext = createContext({
    loadModal: () => null
});
const ModalProvider = memo(({ loadModal, children }) => (_jsx(ModalContext.Provider, { value: {
        loadModal
    }, children: children })));
export const useModalContext = () => useContext(ModalContext);
export default ModalProvider;
//# sourceMappingURL=index.js.map